"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _constants = require("../constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var HMHConsistentIngressAnchor = function HMHConsistentIngressAnchor(_ref) {
  var UtilitiesIconButton = _ref.UtilitiesIconButton,
    UtilitiesIcon = _ref.UtilitiesIcon,
    applicationName = _ref.applicationName,
    icon = _ref.icon;
  var dispatchOpenEvent = function dispatchOpenEvent() {
    var openEvent = new CustomEvent(_constants.EMIT_MESSAGES.HMH_OPEN_FLYOVER, {
      detail: {
        applicationName: applicationName
      }
    });
    document.dispatchEvent(openEvent);
  };
  return /*#__PURE__*/_react["default"].createElement("span", {
    "data-testid": "hmh-consistent-ingress"
  }, /*#__PURE__*/_react["default"].createElement(UtilitiesIconButton, {
    onClick: function onClick() {
      dispatchOpenEvent();
    }
  }, /*#__PURE__*/_react["default"].createElement(UtilitiesIcon, {
    type: icon
  })));
};
var _default = exports["default"] = HMHConsistentIngressAnchor;
//# sourceMappingURL=HMHConsistentIngressAnchor.js.map